import {get} from 'lodash';

export const getClientJourneyTasks = (
  state = {},
  {clientId, type, tasks}: any,
) => {
  return {
    ...state,
    clientJourneyTasks: {
      ...get(state, 'clientJourneyTasks', {}),
      [clientId]: {
        ...get(state, `clientJourneyTasks.${clientId}`, {}),
        [type]: tasks,
      },
    },
  };
};
